import React, { useEffect } from "react";
import Toast, { showToast } from "../../components/Toast";
import { config } from "../../config";
import useScript from "../../hooks/useScript";

const FormLayout = ({ form }) => {
  const wpFormId = form.content?.match("wpcf7-f(.*)-o");

  const disableSubmitButton = (isDisable = true) => {
    const submitButton = document.querySelector("input[type=submit]");
    submitButton.disabled = isDisable;
  };

  const createErrorElement = (message) => {
    const elemError = document.createElement("p");
    elemError.className = "error";
    elemError.innerHTML = message;

    return elemError;
  };

  const customizeForm = (wpFormId) => {
    const formId = `form-campaign-${wpFormId}`;

    const wpContent = form.content.replace(
      /action="(.*?)"/,
      `action="https://wp-api.zipmex.com/wp-json/contact-form-7/v1/contact-forms/${wpFormId}/feedback" id="${formId}"`
    );

    const elemContent = document.getElementById("campaign__content");
    elemContent.innerHTML = wpContent;

    disableSubmitButton();

    const campaignForm = document.getElementById(formId);

    campaignForm.addEventListener("submit", async (event) => {
      event.preventDefault();

      const grecaptcha = document.querySelector(".g-recaptcha-response")?.value;
      if (!grecaptcha) {
        showToast("campaign", "error");
      } else {
        disableSubmitButton();

        fetch(event.target.action, {
          method: "POST",
          body: new FormData(event.target),
        })
          .then((resp) => {
            return resp.json();
          })
          .then((body) => {
            if (body.status === "mail_sent") {
              showToast("campaign", "success");
              campaignForm.reset();
            } else {
              body.invalid_fields.forEach(({ into, message }) => {
                const invalidField = document.querySelector(`${into}`);
                const existingError =
                  invalidField.getElementsByClassName("error");

                const elemError = createErrorElement(message);

                if (!existingError.length) {
                  invalidField.appendChild(elemError);
                } else {
                  invalidField.replaceChild(elemError, existingError[0]);
                }
              });
            }
          })
          .catch((error) => {
            console.error(error);
            showToast("campaign", "error");
          })
          .finally(() => {
            disableSubmitButton(false);
          });
      }
    });
  };

  const renderRecaptcha = () => {
    const verifyCallback = () => {
      disableSubmitButton(false);
    };

    const expiredCallback = () => {
      disableSubmitButton();
    };

    const onloadCallback = () => {
      window.grecaptcha.render("recaptcha-wrapper", {
        sitekey: config.reCaptcha_key,
        callback: verifyCallback,
        "expired-callback": expiredCallback,
      });
    };

    window.onloadCallback = onloadCallback;

    const reCaptchaWrapper = document.createElement("div");
    reCaptchaWrapper.setAttribute("id", "recaptcha-wrapper");

    const submitButton = document.querySelector("input[type=submit]");
    submitButton.before(reCaptchaWrapper);
  };

  useEffect(() => {
    if (wpFormId) {
      customizeForm(wpFormId[1]);
      renderRecaptcha();
    } else {
      document.getElementById("campaign__content").innerHTML = form.content;
    }
  }, []);

  useScript(
    "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
    wpFormId
  );

  return (
    <div className="campaign pt-5 post">
      <Toast
        containerId="campaign"
        toastStatus="success"
        header="Thank you!"
        description="Your form submission has been received."
      />

      <Toast
        containerId="campaign"
        toastStatus="error"
        header="Something went wrong"
        description="Please try again later."
      />

      <div className="container page-content py-5">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <h1
              className="mb-3"
              dangerouslySetInnerHTML={{ __html: form.title }}
            />
            <div id="campaign__content" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
